import * as Types from '../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSingleChargeQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type GetSingleChargeQuery = { __typename?: 'QueryModel', projectCharges?: { __typename?: 'ProjectChargesQueryModel', single?: { __typename?: 'ProjectCharge', id: number, label: string, notes?: string | null, date: string, rate: number, unit?: Types.RateUnit | null, quantity?: number | null, timesheetQuantity?: number | null, eeCode: string, total?: number | null, state: Types.ProjectChargeState, billable: boolean, glAccount?: string | null, taxable: boolean, canAdjust: boolean, canSplit: boolean, canPsApprove: boolean, canBaApprove: boolean, canPmApprove: boolean, canEditTaxable: boolean, canMoveProject: boolean, canPostToInvoice: boolean, canOverrideRate: boolean, lastEditNotes?: string | null, projectId: number, type: Types.ChargeType, rateSheetName?: string | null, isThirdParty: boolean, employee?: { __typename?: 'Employee', firstName: string, lastName: string, middleInitial: string, userPrincipalName: string } | null, history?: Array<{ __typename?: 'ProjectChangedHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeBillableHistoryItem', billable: boolean, editNotes: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEditedHistoryItem', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, editNotes: string, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeEeCodeHistoryItem', eeCode: string, editNotes: string, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeHistoryItemDetailed', label: string, notes?: string | null, rate: number, quantity?: number | null, billable: boolean, eeCode: string, date?: string | null, changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeQuantityHistoryItem', changedBy: string, changedOn: any, event: string } | { __typename?: 'ProjectChargeTaxableHistoryItem', taxable: boolean, changedBy: string, changedOn: any, event: string } | null> | null, project?: { __typename?: 'Project', name: string, number: number, budget?: number | null, afe?: string | null, canAddCharge: boolean, billingAdmin?: { __typename?: 'Employee', firstName: string, lastName: string, middleInitial: string, userPrincipalName: string, ultiProId: string } | null, projectManager?: { __typename?: 'Employee', firstName: string, lastName: string, middleInitial: string, userPrincipalName: string, ultiProId: string } | null, projectSupervisor?: { __typename?: 'Employee', firstName: string, lastName: string, middleInitial: string, userPrincipalName: string, ultiProId: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null, customer?: { __typename?: 'Customer', name: string, number?: string | null } | null, stats?: { __typename?: 'ProjectStats', totalUnbilled: number, totalBilled: number, totalPrPending: number, totalPendingApproval: number, totalPendingBilling: number, totalPmPending: number, totalNonBillable: number } | null, overheadEeCode?: { __typename?: 'EeCodeRecord', eeCode: string } | null } | null } | null } | null };


export const GetSingleChargeDocument = gql`
    query GetSingleCharge($id: Int!) {
  projectCharges {
    single(id: $id) {
      id
      label
      notes
      date
      rate
      unit
      quantity
      timesheetQuantity
      eeCode
      total
      state
      billable
      glAccount
      taxable
      employee {
        firstName
        lastName
        middleInitial
        userPrincipalName
      }
      history {
        changedBy
        changedOn
        event
        ... on ProjectChargeHistoryItemDetailed {
          label
          notes
          rate
          quantity
          billable
          eeCode
          date
        }
        ... on ProjectChargeEditedHistoryItem {
          label
          notes
          rate
          quantity
          billable
          editNotes
          eeCode
          date
        }
        ... on ProjectChargeTaxableHistoryItem {
          taxable
        }
        ... on ProjectChargeBillableHistoryItem {
          billable
          editNotes
        }
        ... on ProjectChargeEeCodeHistoryItem {
          eeCode
          editNotes
        }
      }
      canAdjust
      canSplit
      canPsApprove
      canBaApprove
      canPmApprove
      canEditTaxable
      canMoveProject
      canPostToInvoice
      canOverrideRate
      lastEditNotes
      projectId
      project {
        name
        number
        budget
        billingAdmin {
          firstName
          lastName
          middleInitial
          userPrincipalName
          ultiProId
        }
        projectManager {
          firstName
          lastName
          middleInitial
          userPrincipalName
          ultiProId
        }
        projectSupervisor {
          firstName
          lastName
          middleInitial
          userPrincipalName
          ultiProId
        }
        location {
          state
          county
        }
        customer {
          name
          number
        }
        stats {
          totalUnbilled
          totalBilled
          totalPrPending
          totalPendingApproval
          totalPendingBilling
          totalPmPending
          totalNonBillable
        }
        afe
        canAddCharge
        overheadEeCode {
          eeCode
        }
      }
      type
      rateSheetName
      isThirdParty
    }
  }
}
    `;

/**
 * __useGetSingleChargeQuery__
 *
 * To run a query within a React component, call `useGetSingleChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleChargeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleChargeQuery(baseOptions: Apollo.QueryHookOptions<GetSingleChargeQuery, GetSingleChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleChargeQuery, GetSingleChargeQueryVariables>(GetSingleChargeDocument, options);
      }
export function useGetSingleChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleChargeQuery, GetSingleChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleChargeQuery, GetSingleChargeQueryVariables>(GetSingleChargeDocument, options);
        }
export type GetSingleChargeQueryHookResult = ReturnType<typeof useGetSingleChargeQuery>;
export type GetSingleChargeLazyQueryHookResult = ReturnType<typeof useGetSingleChargeLazyQuery>;
export type GetSingleChargeQueryResult = Apollo.QueryResult<GetSingleChargeQuery, GetSingleChargeQueryVariables>;